module.exports = __webpack_public_path__ + "img/btm_bg.15e12e83.png";